module.exports = __webpack_public_path__ + "img/introduce_img5.0a114896.png";